<template>
  <div>
    <b-card no-body>
      <b-card-title class="py-1 px-2 mb-0 d-flex justify-content-between">
        <div class="profile-title">Profile</div>
        <view-data-button
          :isViewed="isVerified"
          @onViewData="confirmViewData"
        />
      </b-card-title>
      <b-skeleton-wrapper :loading="isLoading">
        <template #loading>
          <b-row class="px-3 pb-3">
            <b-col cols="12" md="6" class="text-center">
              <b-skeleton-img width="160px" height="160px" />
            </b-col>
            <b-col cols="12" md="6">
              <b-skeleton width="90%" height="36px" />

              <div class="detail-container">
                <b-skeleton width="40%" />
                <b-skeleton width="50%" />
                <b-skeleton width="80%" />
                <b-skeleton width="60%" />
              </div>
            </b-col>
          </b-row>
        </template>

        <b-row v-if="noItem" class="px-3 pb-3">
          <card-no-item :text-no-img="'ไม่มีข้อมูล'" :height="100" />
        </b-row>

        <b-row v-else class="px-3 pb-3">
          <b-col cols="12" md="6" class="text-center">
            <img
              :src="profileDetail.imageUrl || mockImage"
              class="profile-image"
            />
            <!-- <div class="d-flex justify-content-center mt-1 ">
              <b-button
                variant="primary"
                class="action-button edit-button"
                @click="openCustomerEditModal"
              >
                <span>Edit</span>
              </b-button>
              <b-button
                variant="outline-danger"
                class="action-button"
                @click="openDeleteWarningModal"
                >{{ 'Delete' }}</b-button
              >
            </div> -->
          </b-col>
          <b-col cols="12" md="6">
            <div
              class="
                d-flex
                justify-content-center justify-content-md-start
                my-1 my-md-0
                mb-0 mb-md-1
              "
            >
              <span class="profile-name" v-if="profileDetail.name">
                {{ profileDetail.name }}</span
              >
            </div>
            <div class="detail-container">
              <profile-detail
                v-for="(value, key) in profileDetail.details"
                :key="`profile-detail-${key}`"
                :icon-type="key"
                :text="value"
              />
            </div>
          </b-col>
        </b-row>
      </b-skeleton-wrapper>
    </b-card>
    <customer-edit-modal
      v-if="modalType.customer"
      :customer-detail="profileDetail"
      @onCloseModal="closeCustomerEditModal"
      @onSubmit="closeCustomerEditModal"
    />
  </div>
</template>

<script>
import {
  BCard,
  BCardTitle,
  BCol,
  BRow,
  BImg,
  BButton,
  BSkeletonWrapper,
  BSkeleton,
  BSkeletonImg,
} from "bootstrap-vue";
import mockImage from "@/assets/images/icons/IconProfile.png";
import CardNoItem from "@core/components/card-no-item/CardNoItem.vue";
import ProfileDetail from "./ProfileDetail.vue";
import CustomerEditModal from "./CustomerEditModal.vue";

import useProfileCard from "../hooks/useProfileCard";
import { onBeforeMount, onMounted, watch, ref, reactive } from "vue-demi";
import EyeIconSvg from "@core/components/svg/common/EyeIcon.vue";
import EyeOffIconSvg from "@core/components/svg/common/EyeOffIcon.vue";
import ViewDataIconSvg from "@core/components/svg/common/ViewDataIcon.vue";
import ViewDataButton from "@/views/components/button/ViewDataButton.vue";

export default {
  components: {
    BCard,
    BCardTitle,
    BCol,
    BRow,
    BImg,
    BButton,
    BSkeletonWrapper,
    BSkeleton,
    BSkeletonImg,
    ProfileDetail,
    CustomerEditModal,
    CardNoItem,
    EyeIconSvg,
    EyeOffIconSvg,
    ViewDataIconSvg,
    ViewDataButton,
  },

  props: {
    queryDataId: Number,
    queryDataKey: String,
  },

  setup(props) {
    const {
      profileDetail,
      isLoading,
      noItem,
      closeValidationModal,
      openDeleteWarningModal,
      openCustomerEditModal,
      closeCustomerEditModal,
      modalType,
      confirmViewData,
      isVerified,
    } = useProfileCard(props.queryDataId, props.queryDataKey);

    return {
      profileDetail,
      mockImage,
      isLoading,
      noItem,
      closeValidationModal,
      openDeleteWarningModal,
      openCustomerEditModal,
      closeCustomerEditModal,
      modalType,
      confirmViewData,
      isVerified,
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/data-management/profile-card.css";
</style>
